import script from "./WidgetNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetNumber.vue?vue&type=script&setup=true&lang=js"

import "./WidgetNumber.vue?vue&type=style&index=0&id=2b03846e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b03846e"]])

export default __exports__